var module = angular.module('octopusApp.tenants');

module.controller('TenantOverviewController', function($scope, $q, $location,tenantState, $state,  busy, unsavedChanges, octopusRepository, octopusTagSets, missingTenantVariablesLoader) {
    var vm = this;
    var tenantId = tenantState.tenantId;
    vm.isSaving = tenantState.isSaving;
    vm.isLoading = tenantState.isLoading;
    vm.save = save;

    function init() {
        tenantState.isLoading.promise(tenantState.load().then(function (tenant) {
            tenantState.tenant = tenant;
            vm.tenant = tenant;
            return octopusTagSets.getAll().then(function (tagSets) {
                vm.tagSets = tagSets;
                vm.hasTagSets = vm.tagSets.length > 0;
                vm.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);
            });
        }));

        tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);
    }
    
    function save() {
        vm.tenant.TenantTags = _.flatten(_.values(vm.selectedTagSets));
        vm.isSaving.promise(octopusRepository.Tenants.modify(vm.tenant).then(function () {
            unsavedChanges.saved();
            $state.reload();
        }));
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/controllers/tenant_overview_controller.js
// module id = 629
// module chunks = 1